import {
  ATTICUS_CONSUMER_APP_HOST,
  ATTICUS_CONSUMER_APP_SIGN_UP,
} from "../constants";

export const getSignUpUrl = function (email?: string): string {
  const emailUrl = email ? `?email=${email}` : "";
  return `${ATTICUS_CONSUMER_APP_HOST}${ATTICUS_CONSUMER_APP_SIGN_UP}${emailUrl}`;
};
